import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AddressConfigTcComponent } from './address-config-tc/address-config-tc.component';
import { AdvisorCodeComponent } from './advisor-code/advisor-code.component';
import { CityOfficesSearchComponent } from './city-offices-search/city-offices-search.component';
import { ConfigurationIntroductionComponent } from './configuration-introduction/configuration-introduction.component';
import { ConfirmPhoneComponent } from './confirm-phone/confirm-phone.component';
import { FourTaxWarningComponent } from './four-tax/four-tax-warning/four-tax-warning.component';
import { OpeningSavingsAccountComponent } from './opening-savings-account/opening-savings-account.component';
import { ReceiveCardComponent } from './receive-card/receive-card.component';
import { PayDayComponent } from './pay-day/pay-day.component';
import { RequestReceivedComponent } from './request-received/request-received.component';
import { MetodoDesembolsoComponent } from '../multiproducto/loan/metodo-desembolso/metodo-desembolso.component';
import { AddLoanComponent } from '../multiproducto/loan/add-loan/add-loan.component';
import { DisbursementOfficeComponent } from './disbursement-office/disbursement-office.component';

const routes: Routes = [
  {
    path: 'city-offices-search',
    component: CityOfficesSearchComponent,
  },
  {
    path: 'disbursement-offices-search',
    component: DisbursementOfficeComponent,
  },
  {
    path: 'configuration-introduction',
    component: ConfigurationIntroductionComponent,
  },
  {
    path: 'receive-card',
    component: ReceiveCardComponent,
  },
  {
    path: 'receive-card-withAccount',
    component: ReceiveCardComponent,
  },
  {
    path: 'address-config-tc',
    component: AddressConfigTcComponent,
  },
  {
    path: 'address-config-tc-multiple',
    component: AddressConfigTcComponent,
  },
  {
    path: 'phone-confirm',
    component: ConfirmPhoneComponent,
  },
  {
    path: 'confirm-phone',
    component: ConfirmPhoneComponent,
  },
  {
    path: 'four-tax-warning',
    component: FourTaxWarningComponent,
  },
  {
    path: 'opening-savings-account',
    component: OpeningSavingsAccountComponent,
  },
  {
    path: 'advisor-code',
    component: AdvisorCodeComponent,
  },
  {
    path: 'pay-day',
    component: PayDayComponent,
  },
  {
    path: 'request-received',
    component: RequestReceivedComponent,
  },
  {
    path: 'add-loan',
    component: AddLoanComponent,
  },
  {
    path: 'outlay-selection',
    component: MetodoDesembolsoComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})

export class ConfigurationRoutes { }
